import React from 'react'
import MemoTable from './MemoTable';
import AddMemoAccordion from './AddMemoAccordion';


export default function MemosTab({ 
    memos, 
    student_uuid,
    setStudentUpdated,
    setSuccessAlertOpen,
    setSuccessAlertMessage,
    setErrorAlertOpen,
    setErrorAlertMessage, 
    socket = null,
    socketConnected = false,
    from_weekly = false,
    getStudentName,
}) {
    return (
        <>
            <AddMemoAccordion 
                student_uuid={student_uuid} 
                setStudentUpdated={setStudentUpdated}
                setSuccessAlertOpen={setSuccessAlertOpen}
                setSuccessAlertMessage={setSuccessAlertMessage}
                setErrorAlertOpen={setErrorAlertOpen}
                setErrorAlertMessage={setErrorAlertMessage}
                socket={socket}
                socketConnected={socketConnected}
                from_weekly={from_weekly}
                getStudentName={getStudentName}
            />
            <MemoTable 
                memos={memos} 
                student_uuid={student_uuid} 
                setStudentUpdated={setStudentUpdated}
                setSuccessAlertOpen={setSuccessAlertOpen}
                setSuccessAlertMessage={setSuccessAlertMessage}
                setErrorAlertOpen={setErrorAlertOpen}
                setErrorAlertMessage={setErrorAlertMessage}
                socket={socket}
                socketConnected={socketConnected}
                from_weekly={from_weekly}
                getStudentName={getStudentName}
            />
        </>
    )
}